<template>
  <div>
    <el-dialog
      :title="showCostList ? '生成费用' : '未生成清单合同'"
      :visible="templeShowDialog"
      width="80%"
      center
      @opened="handleOpen"
      @close="closeDialog"
    >
      <div v-show="!showCostList">
        <SiruiSearch
          ref="baseInfoFormRef"
          :query="baseFormData"
          :label-width="'130px'"
          :columns="formColumnList"
          :rules="formRules"
          @resetBtnClick="resetBtnClickHandler"
          @searchBtnClick="queryBtnClickHandler"
        >
        </SiruiSearch>
        <vxe-table
          ref="contractRef"
          :data="contractList"
          :auto-resize="true"
          :loading="load"
          resizable
          border="outer"
          show-overflow
          show-header-overflow
          header-align="center"
          column-min-width="100"
          @radio-change="handleSelectionChange"
          :fit="true"
          :max-height="'400px'"
          style="margin-top: 20px; width: 100%"
        >
          <vxe-table-column type="checkbox" width="50" fixed="left"> </vxe-table-column>
          <vxe-table-column type="seq" title="序号" width="50"></vxe-table-column>
          <vxe-table-column
            type:html
            v-for="item in contractColumnList"
            :field="item.field"
            :title="item.title"
            :key="item.field"
          >
            <template v-slot="{ row }">
              <template v-if="item.field === 'currencyName'">{{
                row['currencyName'] ? row['currencyName'] : '中国人民币（国际）'
              }}</template>

              <template v-else-if="item.field === 'contractStatus'">{{
                contractStatus?.find((item) => item.value == row['contractStatus'])?.label
              }}</template>
              <template v-else-if="item.field === 'exchangeRate'">{{
                row['exchangeRate'] ? row['exchangeRate'] : '1'
              }}</template>
              <template v-else-if="item.field === 'originalTotalAmount'">{{
                row['originalTotalAmount'] ? row['originalTotalAmount'].toFixed(2) : ''
              }}</template>
              <template v-else-if="item.field === 'domesticTotalAmount'">{{
                row['domesticTotalAmount'] ? row['domesticTotalAmount'].toFixed(2) : ''
              }}</template>
              <template v-else-if="item.field === 'settlementType'">{{
                row.settlementType == '1' ? '预结算' : '终结算'
              }}</template>

              <template v-else>{{ row[item.field] }}</template>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div v-show="showCostList">
        <vxe-table
          ref="costListRef"
          :data="costList"
          :auto-resize="true"
          resizable
          border="outer"
          show-overflow
          show-header-overflow
          header-align="center"
          column-min-width="100"
          @radio-change="costSelectionChange"
          :fit="true"
          :max-height="'400px'"
          style="margin-top: 20px; width: 100%"
        >
          <vxe-table-column type="checkbox" width="50" fixed="left"> </vxe-table-column>
          <vxe-table-column type="seq" title="序号" width="50"></vxe-table-column>
          <vxe-table-column
            type:html
            v-for="item in generateColumnList"
            :field="item.field"
            :title="item.title"
            :key="item.field"
          >
            <template v-slot="{ row }">
              <template v-if="item.field === 'expenseType'">{{
                expenseType?.find((item) => item.value == row['expenseType'])?.label
              }}</template>

              <!-- <template v-else-if="item.field === 'unit'">{{
              basic_unit?.find((item) => item.value == row['unit'])?.label
            }}</template> -->
              <template v-else-if="item.field === 'currencyName'">{{
                row['currencyName'] ? row['currencyName'] : '中国人民币（国际）'
              }}</template>
              <template v-else-if="item.field === 'exchangeRate'">{{
                row['exchangeRate'] ? row['exchangeRate'] : '1'
              }}</template>
              <template v-else-if="item.field === 'originalAmount'">{{
                row['originalAmount'] ? row['originalAmount'].toFixed(2) : ''
              }}</template>
              <template v-else-if="item.field === 'domesticAmount'">{{
                row['domesticAmount'] ? row['domesticAmount'].toFixed(2) : ''
              }}</template>
              <template v-else>{{ row[item.field] }}</template>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="cancel" plain>取消</el-button>
        <el-button v-show="!showCostList" type="primary" @click="create" :loading="load"
          >生成费用</el-button
        >
        <el-button v-show="showCostList" type="primary" @click="save" :loading="load"
          >确认生成</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import { contractColumn, formColumn, generateColumn } from './listContractDialog.js';
  import parkPropertyApi from '@/api/receivablesAndPayables/parkProperty.js';
  import moment from 'moment';
  export default {
    name: 'BatchCreateGenerateDialog',
    props: {
      showDialog: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      contractColumnList() {
        return contractColumn;
      },
      formColumnList() {
        return formColumn();
      },
      generateColumnList() {
        return generateColumn;
      },
      expenseType() {
        return this.$baseRequest.getDictListMapByType('property_settlement_cost');
      },
      contractStatus() {
        return this.$baseRequest.getDictListMapByType('PROPERTY-CONTRACT-STATUS');
      },
    },
    watch: {
      showDialog(var1, var2) {
        this.templeShowDialog = var2;
        this.templeShowDialog = var1;
      },
    },
    data() {
      return {
        showCostList: false,
        templeShowDialog: this.showDialog,
        baseFormData: {
          accountPeriod: '',
          contractNo: '',
          customerName: '',
          contractCompanyNo: '',
          contractDepartmentNo: '',
        },
        formRules: {
          accountPeriod: [{ required: true, message: '请选择应收账期', trigger: 'blur' }],
        },
        multipleSelection: [],
        costmultipleSelection: [],
        contractList: [],
        costList: [],
        load: false,
      };
    },
    methods: {
      // 搜索
      queryBtnClickHandler() {
        this.$refs.baseInfoFormRef.validate((valid) => {
          if (valid) {
            this.$refs.contractRef.clearCheckboxReserve();
            this.getContract();
          }
        });
      },
      // 重置
      resetBtnClickHandler() {
        this.$refs.contractRef.clearCheckboxReserve();
        this.getContract();
      },
      // 选中触发事件
      handleSelectionChange(row) {
        this.multipleSelection = row;
        console.log(row);
      },
      // 费用清单选择
      costSelectionChange(row) {
        this.costmultipleSelection = row;
        console.log(row);
      },
      // 初始化数据
      handleOpen() {
        this.baseFormData.accountPeriod = moment(new Date()).format('YYYY-MM');
        this.baseFormData.contractCompanyNo = this.userInfo.companyCode;
        this.baseFormData.contractDepartmentNo = this.userInfo.departmentCode;
        this.getContract();
      },
      // 获取未生成清单合同
      async getContract() {
        this.loading = true;
        const { data } = await this.$axios.post(
          parkPropertyApi.GET_NOT_GENERATED_CONTRACT,
          this.baseFormData
        );
        if (data.code == 0) {
          this.contractList = data.data;
          this.$nextTick(() => {
            this.$refs.contractRef.setAllCheckboxRow(true);
          });
        }
        this.loading = false;
      },

      // 关闭弹窗
      closeDialog() {
        if (this.showCostList) {
          this.showCostList = false;
        } else {
          this.clearBaseForm();
          this.$emit('closeDialog', false);
        }
      },
      cancel() {
        if (this.showCostList) {
          this.showCostList = false;
        } else {
          console.log('取消');
          this.clearBaseForm();
          this.$emit('closeDialog', false);
        }
      },
      // 生成费用
      create() {
        let selectedList = this.$refs.contractRef.getCheckboxRecords();
        if (!selectedList.length) {
          this.$message.warning('请选择行操作!');
          return;
        }
        this.costList = [];
        selectedList.forEach((item) => this.costList.push(...item.expenses));
        this.showCostList = true;
        this.$nextTick(() => {
          this.$refs.costListRef.setAllCheckboxRow(true);
        });
      },
      // 确认生成
      async save() {
        let selectedList = this.$refs.costListRef.getCheckboxRecords();
        if (!selectedList.length) {
          this.$message.warning('请选择行操作!');
          return;
        }
        selectedList.forEach((item) => {
          item.id = null;
          item.businessCategory = '04';
          item.createMethod = '02';
          item.salesmanName = this.userInfo.personName;
          item.salesmanNo = this.userInfo.personNo;
        });
        const { data } = await this.$axios.post(
          parkPropertyApi.RECEIVABLESEXPENSE_SAVE,
          selectedList
        );
        if (data.code == 0) {
          this.$message.success('创建成功！');
          this.clearBaseForm();
          this.$emit('saveCost');
        } else {
          if (data.msg != null) {
            return this.$message.error(data.msg);
          }
          return this.$message.error('创建失败');
        }
      },
      clearBaseForm() {
        this.baseFormData.accountPeriod = '';
        this.baseFormData.contractNo = '';
        this.baseFormData.customerName = '';
        this.contractList = [];
      },
    },
  };
</script>
<style lang="scss" scoped></style>
